// src/utils/style-generator.js

function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
  
  function isNum(v) {
    if (v === null || v === undefined) return false;
    const n = Number(v);
    return Number.isFinite(n);
  }
  
  /**
   * normalizeBreaks(style, styleType)
   * - style: { breaks: [...] , colorRamp: [...] }
   * - style.breaks lehet:
   *    a) [{ name, values:[a,b], color, type }, ...]
   *    b) [t0, t1, t2, ...] küszöblista => ebből {values:[ti, ti+1]} szabályok lesznek
   * - Itt állítjuk be a Title-nek szánt 'name' mezőt is.
   *   AZ ELSŐ cím: "< b", az UTOLSÓ: "> a", a köztesek: "a - b".
   */
  function normalizeBreaks(style = {}, styleType = 'range') {
    const colors = Array.isArray(style.colorRamp) ? style.colorRamp : [];
    const raw = Array.isArray(style.breaks) ? style.breaks : [];
  
    // Ha már kész objektumok jönnek (values tömbbel), csak töltsük ki a hiányzókat
    if (raw.length && typeof raw[0] === 'object' && raw[0] && Array.isArray(raw[0].values)) {
      return raw.map((r, i, arr) => {
        const [a, b] = r.values || [];
        let name = r.name || '';
        if (!name && r.type !== 'categorical' && styleType !== 'categorical' && isNum(a)) {
          // ha nincs név, de range: csináljunk "< b" / "> a" / "a - b" sémát
          if (i === 0 && b != null) name = `< ${b}`;
          else if (i === arr.length - 1 && a != null) name = `> ${a}`;
          else name = `${a} - ${b}`;
        }
        return {
          name,
          values: r.values,
          color: r.color || colors[i] || '#cccccc',
          type: r.type || styleType
        };
      });
    }
  
    // Ha küszöblista érkezik (t0..tn) => építsünk n-1 darab [ti, ti+1] szabályt
    if (raw.length && (isNum(raw[0]) || typeof raw[0] === 'string')) {
      const rules = [];
      for (let i = 0; i < raw.length - 1; i++) {
        const a = raw[i], b = raw[i + 1];
        let name;
        if (i === 0) name = `< ${b}`;
        else if (i === raw.length - 2) name = `> ${a}`;
        else name = `${a} - ${b}`;
  
        rules.push({
          name,
          values: [a, b],
          color: colors[i] || '#cccccc',
          type: (styleType === 'categorical') ? 'categorical' : 'range'
        });
      }
      if (!rules.length) {
        rules.push({
          name: 'all',
          values: [-Infinity, Infinity],
          color: colors[0] || '#cccccc',
          type: styleType
        });
      }
      return rules;
    }
  
    // Fallback: 1 szabály
    return [{
      name: 'all',
      values: [-Infinity, Infinity],
      color: colors[0] || '#cccccc',
      type: styleType
    }];
  }
  
  function ruleFilter(fieldName, rule) {
    const [a, b] = rule.values;
    const numA = Number(a), numB = Number(b);
    const bothNum = Number.isFinite(numA) && Number.isFinite(numB);
  
    if (rule.type === 'categorical' || (!bothNum) || a === b) {
      const lit = esc(a);
      return `
        <ogc:Filter>
          <ogc:PropertyIsEqualTo>
            <ogc:PropertyName>${esc(fieldName)}</ogc:PropertyName>
            <ogc:Literal>${lit}</ogc:Literal>
          </ogc:PropertyIsEqualTo>
        </ogc:Filter>`;
    }
  
    return `
      <ogc:Filter>
        <ogc:And>
          <ogc:PropertyIsGreaterThan>
            <ogc:PropertyName>${esc(fieldName)}</ogc:PropertyName>
            <ogc:Literal>${esc(a)}</ogc:Literal>
          </ogc:PropertyIsGreaterThan>
          <ogc:PropertyIsLessThanOrEqualTo>
            <ogc:PropertyName>${esc(fieldName)}</ogc:PropertyName>
            <ogc:Literal>${esc(b)}</ogc:Literal>
          </ogc:PropertyIsLessThanOrEqualTo>
        </ogc:And>
      </ogc:Filter>`;
  }
  
  export function generateSld(params, styleType = 'range') {
    const {
      qualifiedName,
      name,
      fieldName,
      style = {}
    } = params || {};
  
    const norm = normalizeBreaks(style, styleType);
    const hatched = !!style?.hatched;
  
    const rulesXml = norm.map((r) => {
      const flt = ruleFilter(fieldName, r);
      
      let fillXml;
      if (hatched) { 
        fillXml = `
            <Rule>
            <Title>${esc(r.name || '')}</Title>
            ${flt}
            <PointSymbolizer>
              <Graphic>
                 <Mark>
                   <WellKnownName>circle</WellKnownName>
                   <Fill>
                     <CssParameter name="fill">${esc(r.color)}</CssParameter>
                     <CssParameter name="fill-opacity">${esc(style.opacity ?? 1)}</CssParameter>
                   </Fill>
                 </Mark>
                 <Size>8</Size>
              </Graphic>
              <Stroke>
              <CssParameter name="stroke">#000000</CssParameter>
              <CssParameter name="stroke-opacity">0</CssParameter>
              <CssParameter name="stroke-width">0</CssParameter>
              </Stroke>
          </PointSymbolizer>
            </Rule>`;
      } else {
        fillXml = `
            <Rule>
            <Title>${esc(r.name || '')}</Title>
            ${flt}
            <PolygonSymbolizer>
                <Fill>
                <CssParameter name="fill">${esc(r.color)}</CssParameter>
                <CssParameter name="fill-opacity">${esc(style.opacity ?? 1)}</CssParameter>
                </Fill>
                <Stroke>
                <CssParameter name="stroke">#000000</CssParameter>
                <CssParameter name="stroke-opacity">0</CssParameter>
                <CssParameter name="stroke-width">0</CssParameter>
                </Stroke>
            </PolygonSymbolizer>
            </Rule>`;
      }

      return fillXml;
    }).join('\n');
  
    const qName = qualifiedName || name;
  
    return `<?xml version="1.0" encoding="UTF-8"?>
  <StyledLayerDescriptor version="1.0.0"
    xsi:schemaLocation="http://www.opengis.net/sld StyledLayerDescriptor.xsd"
    xmlns="http://www.opengis.net/sld"
    xmlns:sld="http://www.opengis.net/sld"
    xmlns:ogc="http://www.opengis.net/ogc"
    xmlns:gml="http://www.opengis.net/gml"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
    <NamedLayer>
      <Name>${esc(qName)}</Name>
      <UserStyle>
        <Name>${esc(qName)}_style</Name>
        <Title>${esc(qName)} style</Title>
        <FeatureTypeStyle>
          ${rulesXml}
        </FeatureTypeStyle>
      </UserStyle>
    </NamedLayer>
  </StyledLayerDescriptor>`;
  }
  
  /* (opcionális) sraffozó konverter – ha később vissza akarod hozni
  export function solidSldToHatch(sldXml, options = {}) { ... }
  */
  